var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMailUndeliverable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2.5h-13A.5.5 0 001 3v10a.5.5 0 00.5.5h13a.5.5 0 00.5-.5V3a.5.5 0 00-.5-.5zm-.625 1.731v8.144H2.125V4.231l-.431-.336.614-.789.669.52h10.048l.669-.52.614.79-.433.335zm-.85-.606L8 7.531 2.975 3.625l-.669-.52-.614.789.431.336 5.338 4.15a.875.875 0 001.073 0l5.341-4.149.431-.336-.614-.789-.667.519z",
    fill: "#595959"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 4,
    r: 4,
    fill: "#FF4D4F"
  })));
}

export default __webpack_public_path__ + "./fonts/mail_undeliverable.c8cdc4bbcef853b6e3fe1e6e29ef41da.svg";
export { SvgMailUndeliverable as ReactComponent };